module.exports = __webpack_public_path__ + "static/Marc-Dickey-S-800x500-2022cac082d91c02dfede61ed3e841ec.jpg";